import { useEffect, useState } from "react";
import EditProfileblm from "./EditProfileblm";
import Blmpostadd from "./Blmpostadd";
import Viewersengagement from "./Viewersengagement";
import Upgradeprofile from "./Upgradeprofile";
import Contactdetaiilsprofile from "./Contactdetaiilsprofile";
import Uploadbannerblm from "./Uploadbannerblm";
import Aboutusblmprofile from "./Aboutusblmprofile";
import Servicesblmprofile from "./Servicesblmprofile";
import Socilallinkprofile from "./Socilallinkprofile";
import Galleryblmprofile from "./Galleryblmprofile";
import Workprogressbar from "./Workprogressbar";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOwnProfile } from "../../Redux/Slice/PostSlice";
import HttpClient from "../../utils/HttpClient";
import BlmEnquiry from "./BlmEnquiry";
import { fetchPageEnquiries, fetchPostEnquiries } from "../../Redux/Slice/EnquirySlice";
import { fetchAllBusinessPosts } from "../../Redux/Slice/BusinessPostSlice";
import PageUnderAdminReview from "./PageUnderReview";
import AddKeywords from "./AddKeywords";
import { useNavigate } from "react-router-dom";
import ProfileSkeleton from "../SearchHome/skeletons/ProfileSkeleton";
// import { Helmet } from "react-helmet-async";
// import profileimg from "../../Images/profileimg.png";
import SeoMetaData from "../../View/BusinessPage/SeoMetaData";

const UserProfile = () => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { UserProfileID, SingleUserData } = useSelector((state) => state.app);
  const { PageEnquiries, PostEnquiries } = useSelector((state) => state.enquiry);
  const { subscriptionId } = location?.state || {};
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const getUserProfileById = async () => {
    const res = await HttpClient.requestData(`single-user/${SingleUserData[0]?._id}`, "GET", {});
    if (res && res?.status) {
      const updatedProfileData = {
        ...res?.data[0],
      };
      setData(updatedProfileData);
    }
    setIsLoading(false)
  };

  const getBusinessDetails = async (slug) => {
    const res = await HttpClient.requestData(`business-details/${slug}`, "GET", {});
    if (res && res?.data?.length) {
      const updatedProfileData = {
        ...res?.data[0],
      };
      setData(updatedProfileData);
      setIsLoading(false)
    } else {
      navigate("/");
    }
  }

  useEffect(() => {
    const name = params?.name;
    if (!name) {
      setData(UserProfileID);
      return;
    }

    const companySlug = UserProfileID?.companySlug || UserProfileID?.companySlug;

    // If route matches current user's id or company slug, use local data
    if (UserProfileID?._id === name || companySlug === name) {
      setData(UserProfileID);
      return;
    }

    const isObjectId = /^[0-9a-fA-F]{24}$/.test(name);
    if (isObjectId) {
      getUserProfileById();
    } else {
      getBusinessDetails(name);
    }
  }, [UserProfileID, params?.name]);

  useEffect(() => {
    if (UserProfileID) {
      dispatch(fetchPageEnquiries())
      dispatch(fetchPostEnquiries())
      dispatch(fetchAllBusinessPosts())
    }
  }, [])

  const [isUpdate, setIsUpdate] = useState(false)
  useEffect(() => {
    if (isUpdate) {
      updateData(data)
      setIsUpdate(false)
    }
  }, [isUpdate])

  const updateData = async (data) => {
    // setIsLoading(true)
    const updatedBusinessData = {
      ...data,
    };

    // Remove properties
    delete updatedBusinessData._id;
    delete updatedBusinessData.password;
    delete updatedBusinessData.token;
    delete updatedBusinessData.SLNo;
    delete updatedBusinessData.TypeOfCompany;
    delete updatedBusinessData.avgRating;
    delete updatedBusinessData.designation;
    delete updatedBusinessData.doc;
    delete updatedBusinessData.likeCount;
    delete updatedBusinessData.likes;
    delete updatedBusinessData.loginStatus;
    delete updatedBusinessData.memberStatus;
    delete updatedBusinessData.partnerStatus;
    delete updatedBusinessData.passwordView;
    delete updatedBusinessData.productData;
    delete updatedBusinessData.rating;
    delete updatedBusinessData.referralStatus;
    delete updatedBusinessData.service;
    delete updatedBusinessData.serviceID;
    delete updatedBusinessData.serviceName;
    delete updatedBusinessData.upgradeStatus;
    delete updatedBusinessData.activationCode;
    delete updatedBusinessData.companyDescription;
    delete updatedBusinessData.companyTypeName;
    delete updatedBusinessData.dribbbleLink;
    delete updatedBusinessData.gender;
    // delete updatedBusinessData.phone_code;
    delete updatedBusinessData.qrCode;
    delete updatedBusinessData.rewardPoints;
    delete updatedBusinessData.updatedOn;
    delete updatedBusinessData.userLink;
    delete updatedBusinessData.userName;
    delete updatedBusinessData.userType;
    delete updatedBusinessData.userTypeName;
    delete updatedBusinessData.videoUrl;
    delete updatedBusinessData.walletPoints;
    delete updatedBusinessData.websiteLink;
    // delete updatedBusinessData.whats_code;
    delete updatedBusinessData.youtubeLink;

    try {
      const response = await HttpClient.requestData(
        `update-business/${UserProfileID?._id}`,
        "PUT",
        updatedBusinessData
      );
      if (response.status) {
        dispatch(getOwnProfile())
        setIsLoading(false)
      } else {
        console.error("Error from listing business");
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      setIsLoading(false)
    } finally {
    }
  }

  const updateForm = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };


  const handlePageVisit = async (id) => {
    try {
      await HttpClient.requestData(`business-page-visit`, "POST", { userId: id });
    } catch (error) {
      console.error("Error recording page visit:", error);
    }
  }

  useEffect(() => {
    data?._id !== UserProfileID?._id && data?._id && handlePageVisit(data?._id);
    setIsLoading(false);
  }, [data?._id])

  return (
    <>
        <SeoMetaData data={data} />
      {
        isLoading ? <section className="ownblmprofiledivmaoin " style={{ paddingTop: "0px" }}> <div className="cust_container"><ProfileSkeleton /></div> </section> :
          (
            <section className="ownblmprofiledivmaoin "
              style={{
                paddingTop: "0px"
              }}
            >
              {data?.status == "Pending" && !data.businessStatus ? (
                <PageUnderAdminReview contactRoute={"lets-get-intouch"} contactPhone={process.env.REACT_APP_CONTACT_PHONE || ""} contactEmail={process.env.REACT_APP_CONTACT_EMAIL || ""} />) : (

                <div className="cust_container">

                  {/* {!UserProfileID?.businessStatus && UserProfileID?._id === data?._id && */}
                  <div className="Workprogressbarmainb">
                    <Workprogressbar data={data} page={3} plan={subscriptionId} />
                  </div>
                  {/* } */}

                  <div className=" reposivecideforspecial">
                    <div className="ownblmprofiledivleft">
                      <div className="repsonsivedivcls">
                        {/* For Tablet responsive code start  */}
                        <div className=" oenblmsnfidivmainleft">
                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                          </div>

                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <Contactdetaiilsprofile
                              setData={setData}
                              data={data}
                              updateForm={updateForm}
                              setIsUpdate={setIsUpdate}
                            />
                          </div>
                        </div>
                        <div className="oenblmsnfidivmainright">
                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                          </div>
                          {
                            UserProfileID?._id === data?._id &&
                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                              <Blmpostadd />
                            </div>
                          }

                          {
                            UserProfileID?._id === data?._id &&
                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                              <Viewersengagement />
                            </div>
                          }

                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                            {UserProfileID?._id === data?._id && <Upgradeprofile />}
                          </div>
                          
                        </div>
                        {/* For Tablet responsive code  end */}
                      </div>

                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                      </div>

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Blmpostadd />
                        </div>
                      }

                      {
                        UserProfileID?._id !== data?._id ?
                          <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                            <BlmEnquiry />
                          </div>
                          :
                          <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">

                            <div className='bmlmmaposttaddddib'>
                              <div className='bmlmmaposttaddddibdivmain'>
                                <div className='poisyybtnmainlibkldivflx'>

                                  <Link className="_direxrrcttstbtn ipyysffraedtn"
                                    style={{
                                      margin: "0 auto",
                                      color: "#fff"
                                    }}
                                    to="/myenquiries"
                                  >
                                    View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                  </Link>

                                </div>
                              </div>
                            </div>

                          </div>
                      }

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Viewersengagement />
                        </div>
                      }

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Upgradeprofile />
                        </div>
                      }

                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <Contactdetaiilsprofile
                          setData={setData}
                          data={data}
                          updateForm={updateForm}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>

                    </div>
                    <div className="ownblmprofiledivright">
                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>
                      <div className="oenblmsnfdrpbapbbtm">
                        <Aboutusblmprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>

                      <div className="oenblmsnfdrpbapbbtm">
                        <Servicesblmprofile
                          data={data}
                          updateForm={updateForm}
                          setData={setData}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm">
                          <AddKeywords data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                        </div>
                      }


                      <div className="oenblmsnfdrpbapbbtm">
                        <Galleryblmprofile
                          setData={setData}
                          data={data}
                          updateForm={updateForm}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>
                      <div className="oenblmsnfdrpbapbbtm">
                        <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                      </div>
                    </div>
                  </div>

                  {/* Mobile Screen Design Start */}

                  <div className="mobilereposiveprofile">
                    <div className="bannerprofileblmreposnive">
                      <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                    </div>
                    <div className="mobilereposvispsicaldivflx">
                      <div className={UserProfileID?._id === data?._id ? "eidteprofileblmreposnive" : 'eidteprofileblmreposnive2'}>
                        <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                      </div>



                      <div className="viewsprofileprofileblmreposnive">
                        {UserProfileID?._id === data?._id &&
                          <div className="bklmlposprofileprofileblmreposnive">
                            <Blmpostadd />
                          </div>
                        }

                        {
                          UserProfileID?._id === data?._id ?
                            <div className="_bklmlposprofileprofileblmreposnive">
                              <div className="oenblmsnfdrpbapbbtm _deslrtopwdijjsmain">

                                <div className='bmlmmaposttaddddib'>
                                  <div className='bmlmmaposttaddddibdivmain'>
                                    <div className='poisyybtnmainlibkldivflx'>

                                      <Link className="direxrrcttstbtn ipyysffraedtn"
                                        style={{
                                          margin: "0 auto",
                                          color: "#fff"
                                        }}
                                        to="/myenquiries"
                                      >

                                        View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                      </Link>

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                            :
                            <div className="_bklmlposprofileprofileblmreposnive">
                              <BlmEnquiry />
                            </div>
                        }

                        {UserProfileID?._id === data?._id &&
                          <div className="bklmlposprofileprofileblmreposnive">
                            <Viewersengagement />
                          </div>
                        }

                        {UserProfileID?._id === data?._id &&
                          <div className="">
                            <Upgradeprofile />
                          </div>
                        }

                      </div>



                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Contactdetaiilsprofile
                        setData={setData}
                        data={data}
                        updateForm={updateForm}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Aboutusblmprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Servicesblmprofile
                        data={data}
                        updateForm={updateForm}
                        setData={setData}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>

                    {
                      UserProfileID?._id === data?._id &&
                      <div className="oenblmsnfdrpbapbbtm">
                        <AddKeywords data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>
                    }

                    <div className="contaallprofileblmreposnive">
                      <Galleryblmprofile
                        setData={setData}
                        data={data}
                        updateForm={updateForm}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                    </div>
                  </div>

                  {/* Mobile Screen Design End */}
                </div>
              )}
            </section>
          )
      }
    </>

  );
};

export default UserProfile;
